import { useEffect, useRef, useState } from 'react';
import themeCss from '../dashboard.css?inline';
import {createPortal} from 'react-dom';
import InsightPanel from '../InsightPanel.jsx';
import PublishedInsights from '../PublishedInsights.jsx';
import {installChartSpotlight} from '../chartSpotlight.js';
import '../insights.css';
import { SERIES } from '../../../shared/styles/tokens.js';

const seriesTokens = Object.fromEntries(SERIES.map((color,i)=>['--dashboard-series-'+i,color]));

export default function LegacyPage({ page, clientId, campaignTab, onCampaignTab, dashboardPage, dashboardPages, onRefreshPages }) {
  const ref = useRef(null);
  const [insight, setInsight] = useState(null);
  const [published,setPublished]=useState(null);
  const [loaded, setLoaded] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setLoaded(null); setError(false);
    page.load().then(result => { if (active) setLoaded(result); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [page, attempt]);
  useEffect(() => {
    const root = ref.current;
    if (!root || !loaded) return;
    setInsight(null);setPublished(null);
    root.innerHTML = loaded.MARKUP;
    if (dashboardPage) {
      root.querySelector('.sub-tabs')?.replaceChildren(...dashboardPages.map(item => {
        const button = document.createElement('button');
        button.className = 'o-subtab'; button.dataset.savedPage = item.id; button.textContent = item.name;
        if (item.id === dashboardPage.id) button.setAttribute('aria-current', 'page');
        button.onclick = () => onCampaignTab(item.id);
        return button;
      }));
    }
    const publish = event => {
      const selection = event.detail;
      if (!selection) { setInsight(null); return; }
      const target = root.querySelector(selection.dataset ? '[data-insight-slot="'+selection.dataset+'"]' : '[data-insight-slot]');
      if (target) setInsight(previous => previous?.target === target && JSON.stringify(previous.selection) === JSON.stringify(selection) ? previous : {target, selection});
    };
    root.addEventListener('dashboard-insights-context', publish);
    const publishComplete=event=>{if(!event.detail){setPublished(null);return;}const target=root.querySelector('[data-insight-slot]');if(target)setPublished({selection:event.detail,target});};
    root.addEventListener('dashboard-published-report',publishComplete);
    const navigate = event => onCampaignTab?.(event.detail);
    root.addEventListener('dashboard-campaign-tab', navigate);
    const refreshPages = () => onRefreshPages?.();
    root.addEventListener('dashboard-refresh-pages', refreshPages);
    root.querySelector('.topnav')?.remove();
    let cleanup;
    try { cleanup = loaded.mount(root); }
    catch (err) { console.error('Dashboard mount failed', err); setError(true); }
    const stopSpotlight=installChartSpotlight(root);
    return () => { stopSpotlight();root.removeEventListener('dashboard-published-report',publishComplete);root.removeEventListener('dashboard-refresh-pages', refreshPages); root.removeEventListener('dashboard-campaign-tab', navigate); root.removeEventListener('dashboard-insights-context', publish); cleanup?.(); root.innerHTML = ''; };
  }, [loaded]);
  return (
    <main className="o-page o-dashboard" style={seriesTokens}>
      {!loaded && !error && <p className="o-state" role="status">Loading dashboard...</p>}
      {error && <div className="o-state o-error" role="alert">Unable to load this dashboard. <button className="o-btn" onClick={() => setAttempt(n => n + 1)}>Retry</button></div>}
      {loaded && <style>{loaded.STYLE + themeCss}</style>}
      <div ref={ref} data-client-id={clientId} data-campaign-tab={campaignTab} data-dashboard-page-id={dashboardPage?.id} data-dashboard-page-name={dashboardPage?.name}/>
      {published && createPortal(<PublishedInsights selection={published.selection} clientId={clientId}/>,published.target)}
      {insight && createPortal(<InsightPanel selection={insight.selection} clientId={clientId}/>, insight.target)}
    </main>
  );
}
